import { useTranslation } from 'react-i18next'

import PerText from '../Text'

export const MeetingModalStatusHeader = ({ heading }: { heading: string }): JSX.Element => {
  const { t } = useTranslation()

  return (
    <PerText fontSize="xl" color="primary" testId="MeetingModalStatusHeader">
      {t(heading)}
    </PerText>
  )
}
